<nav id="navbar" aria-label="breadcrumb" *ngIf="breadcrumbs.length > 0">
  <div class="container">
    <div class="row">
      <div class="col-6">
        <ol class="breadcrumb header-group">
          <!--<div class="row col-md-8">-->
          <li *ngFor="let bc of breadcrumbs"
            [class]="bc.key == 'active' ? 'breadcrumb-item active' : 'breadcrumb-item'">
            {{bc.key == "active" ? bc.value : ""}}
            <a *ngIf="bc.key != 'active'" [routerLink]="[bc.key]">{{bc.value}}</a>
          </li>
          <!--</div>-->
        </ol>
      </div>
      <div class="col-2">
        <div class="breadcrumb-button">
          <!--<button class="btn" type="button" [routerLink]="'../deploymentCalendar'">Schedule</button>-->
          <a class="btn btn-calendar" target="_blank"
            href="https://outlook.office365.com/calendar/published/6ff7ada130204eddb41fb25190178fca@us.hctx.net/1fe204570cf64bb18ead3c8c5bd233968195777942628600442/calendar.html">Release
            Calendar</a>
        </div>
      </div>
      <div class="col-4" *ngIf="!admin">
        <div class="input-group search-entry" *ngIf="breadcrumbs.length == 1">
          <input class="form-control py-2 border-right-0 border" type="search" placeholder="Filter applications"
            [(ngModel)]='filterItem'>
        </div>
        <div class="input-group search-entry" *ngIf="breadcrumbs.length > 1">
          <input class="form-control py-2 border-right-0 border" type="search" placeholder="Search all release notes"
            [(ngModel)]='searchItem' (keydown.enter)='onSearch(searchItem);'>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary border-left-0 border btn-search" type="submit"
              (click)='onSearch(searchItem);'></button>
          </div>
        </div>
      </div>

      <div class="col-2" *ngIf="admin"></div>
      <div class="col-2" *ngIf="admin">
        <div class="breadcrumb-button">
          <a class="btn btn-admin" routerLink="/administration">Administrator Home</a>
        </div>
      </div>



    </div>
  </div>
</nav>